import axios from 'axios';
import { LeaseValidationRequest } from 'models/request';
import { LeaseValidationResponse } from 'models/response';
import { trackPromise } from 'react-promise-tracker';
import { FLOW_ENGINE } from 'utils/constants';

const leaseValidate = (body: LeaseValidationRequest, loaderArea: 'module' | 'modal' = 'module') =>
  trackPromise(axios.post<LeaseValidationResponse>(`${FLOW_ENGINE}/execute`, body), loaderArea);

export default {
  leaseValidate,
};
